const ru = {
  "nav_home": "Главная",
  "nav_about": "О нас",
  "nav_services": "Услуги",
  "nav_blog": "Блог",
  "nav_login": "Войти",
  "nav_register": "Регистрация",
  "nav_dashboard": "Кабинет",
  "nav_logout": "Выйти",
  "hero_title": "Глобальная платформа инвойс-финансирования",
  "hero_subtitle": "TradeFlow - цифровая платформа привлечения, андеррайтинга и сопровождения трансграничного B2B-инвойс-финансирования. Финансирование предоставляют банки, факторы и private credit партнеры.",
  "hero_cta": "Смотреть демо-сделку",
  "hero_secondary": "Как это работает",
  "scoring_title": "Предварительная оценка",
  "scoring_subtitle": "Оцените лимит финансирования для иллюстративной сделки за 2 минуты",
  "scoring_company": "Название компании",
  "scoring_revenue": "Годовая выручка ($)",
  "scoring_years": "Лет в бизнесе",
  "scoring_industry": "Отрасль",
  "scoring_country": "Страна",
  "scoring_invoices": "Неоплаченные счета ($)",
  "scoring_financial": "Есть финансовая отчетность",
  "scoring_bank": "Есть банковские выписки",
  "scoring_submit": "Рассчитать лимит",
  "scoring_result_title": "Результат оценки",
  "scoring_score": "Скоринг балл",
  "scoring_risk": "Уровень риска",
  "scoring_limit": "Предварительный лимит",
  "scoring_recommendations": "Рекомендации",
  "risk_low": "Низкий",
  "risk_moderate": "Умеренный",
  "risk_elevated": "Повышенный",
  "risk_high": "Высокий",
  "industry_manufacturing": "Производство",
  "industry_trade": "Торговля",
  "industry_services": "Услуги",
  "industry_logistics": "Логистика",
  "industry_agriculture": "Сельское хозяйство",
  "industry_it": "IT",
  "industry_construction": "Строительство",
  "industry_other": "Другое",
  "auth_login_title": "Вход в систему",
  "auth_register_title": "Регистрация",
  "auth_email": "Email",
  "auth_password": "Пароль",
  "auth_confirm_password": "Подтвердите пароль",
  "auth_full_name": "Полное имя",
  "auth_company": "Название компании",
  "auth_phone": "Телефон",
  "auth_role": "Тип аккаунта",
  "auth_submit_login": "Войти",
  "auth_submit_register": "Зарегистрироваться",
  "auth_no_account": "Нет аккаунта?",
  "auth_have_account": "Уже есть аккаунт?",
  "auth_social_login": "Войти через",
  "auth_coming_soon": "Скоро",
  "role_client_buyer": "Покупатель / импортер",
  "role_client_seller": "Продавец / экспортер",
  "role_agent": "Ориджинатор / агент",
  "role_partner_investor": "Инвестор",
  "role_partner_institution": "Банк / финансовый партнер",
  "dash_overview": "Обзор",
  "dash_documents": "Документы",
  "dash_invoices": "Счета-фактуры",
  "dash_deals": "Сделки",
  "dash_offers": "Предложения",
  "dash_blog": "Блог",
  "dash_settings": "Настройки",
  "dash_analytics": "Аналитика",
  "dash_users": "Пользователи",
  "dash_scoring": "Скоринг",
  "stats_total_financed": "Всего профинансировано",
  "stats_active_deals": "Активные сделки",
  "stats_exposure": "Доступный лимит",
  "stats_pending": "На рассмотрении",
  "action_upload": "Загрузить",
  "action_create": "Создать",
  "action_edit": "Редактировать",
  "action_delete": "Удалить",
  "action_view": "Просмотр",
  "action_approve": "Одобрить",
  "action_reject": "Отклонить",
  "action_fund": "Профинансировать",
  "action_publish": "Опубликовать",
  "action_save": "Сохранить",
  "action_cancel": "Отмена",
  "section_stories": "Что показывает демо",
  "section_offers": "Партнерские возможности",
  "section_logistics": "Логистические услуги",
  "section_how_it_works": "Как это работает",
  "section_partners": "Наши партнеры",
  "footer_about": "О платформе",
  "footer_contact": "Контакты",
  "footer_terms": "Условия использования",
  "footer_privacy": "Политика конфиденциальности",
  "footer_copyright": "© 2024 TradeFlow. Все права защищены.",
  "msg_success": "Успешно",
  "msg_error": "Ошибка",
  "msg_loading": "Загрузка...",
  "msg_no_data": "Нет данных",
  "nav": {
    "demo": "Демо"
  },
  "hero": {
    "badge": "Глобальная платформа инвойс-финансирования",
    "statSpeedValue": "60д",
    "statSpeedLabel": "Типичный срок платежа",
    "statAdvanceValue": "80%",
    "statAdvanceLabel": "Примерная ставка аванса",
    "statPartnersValue": "4",
    "statPartnersLabel": "Участника процесса",
    "approvedTitle": "Демо-сделка одобрена",
    "approvedMeta": "Заявка на финансирование $160,000"
  },
  "demo": {
    "badge": "Иллюстративная демо-сделка",
    "title": "Один трансграничный инвойс от подачи до погашения",
    "subtitle": "Это не реальная сделка. Раздел показывает архитектуру транзакции, которую TradeFlow может привлекать, андеррайтить и обслуживать для банков, факторов и private credit партнеров.",
    "caseTitle": "Демо-кейс: счет за промышленное оборудование",
    "sellerLabel": "Китайский продавец",
    "buyerLabel": "Казахстанский покупатель",
    "corridorLabel": "Corridor",
    "statusLabel": "Статус",
    "metrics": {
      "invoice": "Счет",
      "term": "Срок оплаты",
      "advance": "Аванс",
      "financing": "Требуемое финансирование",
      "pricing": "Ориентир ставки",
      "fee": "Комиссия TradeFlow"
    },
    "roles": {
      "seller": {
        "title": "Seller view",
        "items": [
          "Invoice submitted",
          "Buyer confirmed",
          "$160,000 funding ready"
        ]
      },
      "buyer": {
        "title": "Buyer view",
        "items": [
          "Invoice reviewed",
          "Payment obligation confirmed",
          "Due in 60 days"
        ]
      },
      "underwriter": {
        "title": "Underwriter view",
        "items": [
          "Risk grade B+",
          "Documents verified",
          "Recommended advance 80%"
        ]
      },
      "funder": {
        "title": "Funder view",
        "items": [
          "$160,000 deployment",
          "60-day tenor",
          "Repayment source: buyer payment"
        ]
      }
    },
    "steps": [
      {
        "title": "Seller submits invoice",
        "detail": "Chinese supplier uploads invoice, contract, shipment evidence and buyer details."
      },
      {
        "title": "Buyer confirms obligation",
        "detail": "Kazakh buyer confirms the invoice, payment date and non-dispute status."
      },
      {
        "title": "TradeFlow underwrites",
        "detail": "Seller, buyer, invoice evidence, tenor, corridor and fraud controls are scored."
      },
      {
        "title": "Funder finances receivable",
        "detail": "Bank, factor or fund deploys $160,000 against the approved receivable."
      },
      {
        "title": "Buyer repays at maturity",
        "detail": "Buyer pays $200,000 after 60 days; funder receives capital and return."
      }
    ],
    "lenderTitle": "В этой демо-сделке TradeFlow не выступает кредитором.",
    "lenderText": "Платформа отвечает за привлечение, андеррайтинг, документы, подтверждения и сервисинг. Банк, фактор или кредитный фонд финансирует дебиторскую задолженность.",
    "cta": "Смотреть процесс"
  },
  "scoring": {
    "empty": "Заполните форму для получения предварительной оценки",
    "fullAssessment": "Получить полную оценку",
    "industryPlaceholder": "Выберите отрасль"
  },
  "how": {
    "title": "Простой путь от счета к финансированию",
    "steps": [
      {
        "title": "Загрузите документы",
        "description": "Счет, контракт, подтверждение отгрузки и корпоративные документы собираются в одном процессе."
      },
      {
        "title": "Получите оценку",
        "description": "TradeFlow оценивает продавца, покупателя, документы, срок и торговый коридор."
      },
      {
        "title": "Подключите партнера",
        "description": "Одобренные задолженности готовятся для банков, факторов или кредитных фондов."
      },
      {
        "title": "Получите финансирование",
        "description": "Продавец получает аванс, а TradeFlow сопровождает сделку до погашения."
      }
    ]
  },
  "stories": {
    "title": "What the demo proves",
    "cards": [
      {
        "quote": "A bank can see the borrower, buyer, evidence package and economics in one place.",
        "author": "Funding partner",
        "company": "Kazakhstan bank / fund",
        "role": "Balance sheet provider"
      },
      {
        "quote": "A supplier can request early payment without becoming the lender or negotiating manually with each institution.",
        "author": "Chinese exporter",
        "company": "Demo Machinery Co.",
        "role": "Seller"
      },
      {
        "quote": "A buyer can confirm the commercial obligation and payment date without changing the trade relationship.",
        "author": "Kazakh importer",
        "company": "Demo Distribution LLP",
        "role": "Buyer"
      }
    ]
  },
  "offers": {
    "title": "Partner roles TradeFlow is seeking",
    "cards": [
      {
        "title": "Funding partners",
        "description": "Banks, factors and private credit funds that want qualified cross-border invoices.",
        "company": "Capital providers",
        "offer_type": "financing"
      },
      {
        "title": "Origination partners",
        "description": "Logistics, exporter and importer networks that can surface real transactions.",
        "company": "Distribution partners",
        "offer_type": "logistics"
      },
      {
        "title": "Institutional pilots",
        "description": "Kazakhstan trade-finance teams willing to test underwriting requirements on demo cases.",
        "company": "Pilot partners",
        "offer_type": "service"
      }
    ],
    "detail": "Details"
  },
  "footer": {
    "tagline": "Цифровое привлечение, андеррайтинг и сервисинг трансграничного receivables finance.",
    "companyHeading": "Компания",
    "servicesHeading": "Услуги",
    "legalHeading": "Правовая информация",
    "careers": "Партнерство",
    "factoring": "Финансирование дебиторки",
    "tradeFinance": "Trade finance workflow",
    "bnpl": "Институциональные funding rails"
  },
  "home": {
    "nav": {
      "demo": "Демо-сделка"
    },
    "hero": {
      "badge": "Глобальная платформа инвойс-финансирования",
      "statSpeedValue": "60д",
      "statSpeedLabel": "Типичный срок платежа",
      "statAdvanceValue": "80%",
      "statAdvanceLabel": "Примерная ставка аванса",
      "statPartnersValue": "4",
      "statPartnersLabel": "Участника процесса",
      "approvedTitle": "Демо-задолженность одобрена",
      "approvedMeta": "Заявка на финансирование $160,000"
    },
    "demo": {
      "badge": "Иллюстративная демо-сделка",
      "title": "Один трансграничный инвойс от подачи до погашения",
      "subtitle": "Это не реальная сделка. Раздел показывает архитектуру транзакции, которую TradeFlow может привлекать, андеррайтить и сопровождать для банков, факторов и private credit партнеров.",
      "caseTitle": "Демо-кейс: счет за промышленное оборудование",
      "sellerLabel": "Китайский продавец",
      "buyerLabel": "Казахстанский покупатель",
      "corridorLabel": "Коридор",
      "statusLabel": "Статус",
      "statusValue": "Одобрено для финансирования",
      "metrics": {
        "invoice": "Счет",
        "term": "Срок оплаты",
        "advance": "Аванс",
        "financing": "Требуемое финансирование",
        "pricing": "Ориентир ставки",
        "fee": "Комиссия TradeFlow"
      },
      "roles": {
        "seller": {
          "title": "Кабинет продавца",
          "items": [
            "Счет загружен",
            "Покупатель подтвердил",
            "$160,000 готовы к финансированию"
          ]
        },
        "buyer": {
          "title": "Кабинет покупателя",
          "items": [
            "Счет проверен",
            "Платежное обязательство подтверждено",
            "Срок оплаты - 60 дней"
          ]
        },
        "underwriter": {
          "title": "Кабинет андеррайтера",
          "items": [
            "Риск-рейтинг B+",
            "Документы проверены",
            "Рекомендованный аванс 80%"
          ]
        },
        "funder": {
          "title": "Кабинет фондера",
          "items": [
            "$160,000 к размещению",
            "Срок 60 дней",
            "Источник погашения: платеж покупателя"
          ]
        }
      },
      "steps": [
        {
          "title": "Продавец подает счет",
          "detail": "Китайский поставщик загружает счет, контракт, подтверждение отгрузки и данные покупателя."
        },
        {
          "title": "Покупатель подтверждает обязательство",
          "detail": "Казахстанский покупатель подтверждает счет, дату платежа и отсутствие спора."
        },
        {
          "title": "TradeFlow проводит андеррайтинг",
          "detail": "Оцениваются продавец, покупатель, документы, срок, коридор и признаки мошенничества."
        },
        {
          "title": "Финансовый партнер финансирует дебиторку",
          "detail": "Банк, фактор или фонд размещает $160,000 под одобренную задолженность."
        },
        {
          "title": "Покупатель платит в дату погашения",
          "detail": "Через 60 дней покупатель платит $200,000; фондер получает капитал и доход."
        }
      ],
      "lenderTitle": "В этой демо-сделке TradeFlow не выступает кредитором.",
      "lenderText": "Платформа отвечает за привлечение, андеррайтинг, документы, подтверждения и сервисинг. Банк, фактор или кредитный фонд финансирует дебиторскую задолженность.",
      "cta": "Смотреть процесс"
    },
    "roles": {
      "badge": "Роли на платформе",
      "title": "Выберите свою роль в сделке",
      "subtitle": "TradeFlow построен вокруг реальных участников трансграничного финансирования дебиторской задолженности, а не вокруг одного общего типа пользователя.",
      "cta": "Зарегистрироваться с нужной ролью",
      "items": [
        {
          "title": "Продавец / экспортер",
          "description": "Загружает счета, контракты и подтверждение отгрузки; запрашивает раннюю оплату под подтвержденную дебиторку."
        },
        {
          "title": "Покупатель / импортер",
          "description": "Подтверждает действительность счета, дату платежа и отсутствие спора, чтобы фондер мог опираться на обязательство."
        },
        {
          "title": "Ориджинатор / агент",
          "description": "Приводит продавцов, покупателей или торговые сделки и помогает собрать чистый пакет для финансирования."
        },
        {
          "title": "Инвестор",
          "description": "Смотрит одобренные задолженности, экономику, срок и риск-рейтинг перед размещением капитала."
        },
        {
          "title": "Банк / финансовый партнер",
          "description": "Предоставляет фондирование или факторинговую линию, пока TradeFlow ведет привлечение, процесс и сервисинг."
        }
      ]
    },
    "scoring": {
      "empty": "Заполните форму для получения предварительной оценки",
      "fullAssessment": "Получить полную оценку",
      "industryPlaceholder": "Выберите отрасль",
      "companyPlaceholder": "Demo Trading LLP",
      "revenuePlaceholder": "500000",
      "invoicesPlaceholder": "200000"
    },
    "how": {
      "title": "Простой путь от счета к финансированию",
      "steps": [
        {
          "title": "Загрузите документы",
          "description": "Счет, контракт, подтверждение отгрузки и корпоративные документы собираются в одном процессе."
        },
        {
          "title": "Получите оценку",
          "description": "TradeFlow оценивает продавца, покупателя, документы, срок и торговый коридор."
        },
        {
          "title": "Подключите партнера",
          "description": "Одобренные задолженности готовятся для банков, факторов или кредитных фондов."
        },
        {
          "title": "Получите финансирование",
          "description": "Продавец получает аванс, а TradeFlow сопровождает сделку до погашения."
        }
      ]
    },
    "stories": {
      "title": "Что демонстрирует TradeFlow",
      "cards": [
        {
          "quote": "Банк видит заемщика, покупателя, пакет подтверждений и экономику сделки в одном месте.",
          "author": "Финансовый партнер",
          "company": "Банк / фонд в Казахстане",
          "role": "Поставщик капитала"
        },
        {
          "quote": "Поставщик может запросить досрочную оплату без ручных переговоров с каждым финансовым институтом.",
          "author": "Китайский экспортер",
          "company": "Demo Machinery Co.",
          "role": "Продавец"
        },
        {
          "quote": "Покупатель подтверждает коммерческое обязательство и дату платежа, не меняя торговые отношения.",
          "author": "Казахстанский импортер",
          "company": "Demo Distribution LLP",
          "role": "Покупатель"
        }
      ]
    },
    "offers": {
      "title": "Каких партнеров ищет TradeFlow",
      "detail": "Подробнее",
      "cards": [
        {
          "title": "Финансовые партнеры",
          "description": "Банки, факторы и private credit фонды, которым нужны отобранные трансграничные инвойсы.",
          "company": "Поставщики капитала",
          "offer_type": "financing"
        },
        {
          "title": "Партнеры по привлечению",
          "description": "Логистические, экспортные и импортные сети, которые могут находить реальные сделки.",
          "company": "Партнеры дистрибуции",
          "offer_type": "logistics"
        },
        {
          "title": "Институциональные пилоты",
          "description": "Команды торгового финансирования в Казахстане, готовые тестировать требования к андеррайтингу на демо-кейсах.",
          "company": "Пилотные партнеры",
          "offer_type": "service"
        }
      ]
    },
    "footer": {
      "tagline": "Цифровое привлечение, андеррайтинг и сервисинг трансграничного финансирования дебиторской задолженности.",
      "companyHeading": "Компания",
      "servicesHeading": "Услуги",
      "legalHeading": "Правовая информация",
      "careers": "Партнерство",
      "factoring": "Финансирование дебиторки",
      "tradeFinance": "Процесс торгового финансирования",
      "bnpl": "Институциональная инфраструктура фондирования"
    }
  },
    "authPage": {
      "sideTitle": "Оборотный капитал для роста трансграничной торговли",
      "sideSubtitle": "Доступ к процессу инвойс-финансирования для трансграничных B2B-сделок.",
      "financed": "Демо-объем",
      "clients": "Участники",
      "speedValue": "60д",
      "speed": "Типичный срок",
      "loginDescription": "Войдите в свой аккаунт",
      "registerDescription": "Создайте аккаунт для начала работы",
      "welcome": "Добро пожаловать",
      "loginError": "Ошибка входа",
      "passwordsMismatch": "Пароли не совпадают",
      "passwordTooShort": "Пароль должен содержать минимум 6 символов",
      "registerSuccess": "Регистрация успешна",
      "registerError": "Ошибка регистрации",
      "fullNamePlaceholder": "Иван Петров",
      "companyPlaceholder": "Demo Trading LLP",
      "showPasswords": "Показать пароли",
      "hidePasswords": "Скрыть пароли"
    },
    "dashboard": {
      "clients": "Клиенты",
      "portfolio": "Портфель",
      "search": "Поиск...",
      "welcome": "Добро пожаловать",
      "accountSummary": "Вот что происходит в вашем аккаунте",
      "notCompleted": "Не пройден",
      "users": "Пользователи",
      "recentDeals": "Последние сделки",
      "noDeals": "Нет сделок",
      "profile": "Профиль",
      "name": "Имя",
      "company": "Компания",
      "phone": "Телефон",
      "interfaceLanguage": "Язык интерфейса",
      "socialAccounts": "Социальные сети",
      "linkedAccounts": "Привязанные аккаунты для входа",
      "languageChanged": "Язык изменен",
      "monthlyRevenue": "Выручка за месяц",
      "totalDeals": "Всего сделок",
      "conversion": "Конверсия",
      "keyMetrics": "Ключевые показатели",
      "invoicesMetric": "Счета-фактуры",
      "activeUsers": "Активен",
      "blockedUsers": "Заблокирован",
      "blockUser": "Заблокировать",
      "unblockUser": "Разблокировать",
      "offersSoon": "Управление предложениями скоро будет доступно",
      "blogSoon": "Управление блогом скоро будет доступно",
      "table": {
        "amount": "Сумма",
        "advance": "Аванс",
        "status": "Статус",
        "date": "Дата",
        "title": "Название",
        "type": "Тип",
        "size": "Размер",
        "number": "Номер",
        "debtor": "Дебитор",
        "dueDate": "Срок оплаты",
        "fee": "Комиссия",
        "role": "Роль"
      },
      "documents": {
        "uploadTitle": "Загрузить документ",
        "type": "Тип документа",
        "title": "Название",
        "description": "Описание",
        "file": "Файл",
        "selectFile": "Выберите файл",
        "loadError": "Ошибка загрузки документов",
        "uploadSuccess": "Документ загружен",
        "uploadError": "Ошибка загрузки",
        "deleteSuccess": "Документ удален",
        "deleteError": "Ошибка удаления",
        "invoice": "Счет-фактура",
        "financial_statement": "Финансовая отчетность",
        "bank_statement": "Банковская выписка",
        "incorporation": "Учредительные документы",
        "contract": "Договор",
        "other": "Другое"
      },
      "invoices": {
        "createTitle": "Новый счет-фактура",
        "number": "Номер счета",
        "debtor": "Дебитор",
        "issueDate": "Дата выставления",
        "dueDate": "Срок оплаты",
        "factoring": "Факторинг",
        "loadError": "Ошибка загрузки счетов",
        "createSuccess": "Счет создан",
        "createError": "Ошибка создания счета",
        "factoringSuccess": "Заявка на факторинг отправлена"
      },
      "deals": {
        "loadError": "Ошибка загрузки сделок",
        "approveSuccess": "Сделка одобрена",
        "fundSuccess": "Сделка профинансирована"
      },
      "usersTab": {
        "loadError": "Ошибка загрузки пользователей",
        "statusChanged": "Статус изменен"
      },
      "status": {
        "pending_approval": "На рассмотрении",
        "pending_review": "На проверке",
        "pending": "На рассмотрении",
        "approved": "Одобрено",
        "funded": "Профинансировано",
        "rejected": "Отклонено",
        "active": "Активен"
      },
      "genericError": "Ошибка"
    }
};

export default ru;
